import { secureApi } from './secureApi';

// WHO SUPPLIED THE DEMAND on one booking — the only input to the reduced-commission
// exception (tasks/owner-sourced-commission-tier.md).
//
// Its own service and its own endpoint rather than a field on the booking-edit payload,
// and the reason is not tidiness: the edit route refuses any COMPLETED booking, which is
// correct for dates and money on a finished stay and fatal here — a booking completes at
// checkout, days or weeks before its billing month closes, so the realistic case
// (spotting a misclassification while preparing the month) was exactly the one the edit
// path could not serve. Same split, same reasoning as guestArrivalApi / relocationApi.
const commissionTierApi = {
  // PATCH /api/v1/bookings/:id/commission-tier
  // Body: { sourcedBy: 'host_me' | 'owner', reason?: String }
  //
  // The server refuses an OTA booking, a cancelled one, and any booking already frozen
  // into a finalised month — that last one answers 409 with the month in `details`, so
  // the caller can say WHICH month to reopen rather than «حدث خطأ».
  set: async (bookingId, sourcedBy, reason) => {
    const response = await secureApi.patch(
      `/api/v1/bookings/${bookingId}/commission-tier`,
      { sourcedBy, reason: reason || undefined }
    );
    return response.data;
  }
};

export default commissionTierApi;
